import React from 'react';
import styles from './BlogContentCard.module.css';

const formatDate = (timestamp) => {
  // expects unix timestamp in seconds
  const d = new Date(Number(timestamp) * 1000);
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

const BlogContentCard = ({ blog }) => {
  const { title, label, content, image } = blog;
  const { excerpt, time, readingTime, body, conclusion } = content;

  return (
    <div className={styles.card}>
      <div className={styles.cardContent}>
      <div className={styles.category}>{label}</div>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.excerpt}>{excerpt}</div>
      <div className={styles.meta}>
        <span><i className="ri-time-line"></i> {formatDate(time)}</span>
    
        <span><i className="ri-book-open-line"></i> {readingTime} min read</span>
      </div>
      <div className={styles.imageContainer }>

      <img src={image.imageUrl} alt={title} className={styles.image} />
      </div>
      <div className={styles.body}>
        <div dangerouslySetInnerHTML={{ __html: body.introduction }} />
        {Object.keys(body)
          .filter((key) => key.startsWith('section'))
          .map((key) => (
            <div key={key} className={styles.section}>
              <div dangerouslySetInnerHTML={{ __html: body[key].heading }} />
              <div dangerouslySetInnerHTML={{ __html: body[key].content }} />
            </div>
          ))}
      </div>
      <div className={styles.conclusionBox}>
        <h4>Conclusion</h4>
        <div dangerouslySetInnerHTML={{ __html: conclusion }} />
      </div>
      </div>
    </div>
  );
};

export default BlogContentCard;
